import React, { useState, useEffect } from 'react'
import './dialog.css'

export default function Dialog (props) {
  const {
    show = false,
    okText = '确定',
    cancelText = '取消',
    className = '',
    title = '',
    children,
    onClose = () => {},
    onOk = () => {},
    onCancel = () => {}
  } = props

  const [open, setOpen] = useState(show)

  const handleClose = () => {
    onClose()
  }

  const handleOk = () => {
    onOk()
  }

  const handleCancel = () => {
    onCancel()
  }

  useEffect(() => {
    setOpen(show)
  }, [show])

  return (
    <div className={`dialog-cover v-middle ${className} ${open ? 'dialog-open' : ''}`}>
      <div className="dialog v-middle-content">
        <i className="dialog-close icon-close" onClick={handleClose} />
        {
          !!title &&
            <div className="dialog-title">{title}</div>
        }
        <div className="dailog-content">
          {children}
        </div>
        {
          (okText || cancelText) &&
            <div className="dialog-options">
              <button type="button" className="dialog-btn dialog-btn-primary" onClick={handleOk}>{okText}</button>
              <button type="button" className="dialog-btn" onClick={handleCancel}>{cancelText}</button>
            </div>
        }
      </div>
    </div>
  )
}
